<!-- Bare animated loading spinner icon (requires caller-provided sizing/color). -->

<script lang="ts" setup>
import Loader from '@sigma/assets/loader.svg?component';
// This component always require styling (colors and size)
</script>

<template>
  <Loader aria-busy="true" />
</template>
